import { createAppointment } from "../../../../api/clinic/bookingApi.js";
import { toLocalISODate, getFollowupTimeHHMM } from "../utils/dateTimeHelpers.js";

export const scheduleFollowUpIfNeeded = async (consultationData, reviewDraft) => {
  if (!reviewDraft?.followUpDate) return null;

  const patientid = consultationData?.patientId;
  if (!patientid) {
    throw new Error("Unable to book follow-up: missing patientId.");
  }

  const followUpDate = new Date(reviewDraft.followUpDate);
  const preferreddate = toLocalISODate(followUpDate);
  const preferredtime = reviewDraft?.followUpTime || getFollowupTimeHHMM(followUpDate);

  try {
    await createAppointment({
      patientid,
      preferreddate,
      preferredtime,
    });
    return { success: true };
  } catch (e) {
    const errorMessage = e?.response?.data?.message || e?.message || "Failed to auto-book follow-up appointment";
    throw new Error(errorMessage);
  }
};
